import { getCountries } from '../api/locations-api';
import useRequest from './useRequest';

const useCountryOptions = () => {
  const request = useRequest(getCountries, undefined, {
    responseModifier: (data) => data.map(({ country_code, name }) => ({ id: country_code, label: name })),
  });

  return {
    countryOptions: request.data || [],
    loading: request.loading,
  };
};

export default useCountryOptions;
